import React from 'react';
import { withNodeHandles } from './withNodeHandles';
import { NodeData } from '../../store/store';

// Type definitions
interface FilterRowsContentProps {
  data?: NodeData;
  _type?: string;
}

const FilterRowsContent: React.FC<FilterRowsContentProps> = ({ data, _type }) => (
  <span>{data?.label || 'Filter Rows'}</span>
);

FilterRowsContent.displayName = 'FilterRowsContent';

const FilterRowsNode = withNodeHandles(FilterRowsContent);
FilterRowsNode.displayName = 'FilterRowsNode';

export default FilterRowsNode;
